import React, { useState } from 'react';
import { Badge, Tooltip, Button } from 'antd';
import BatchCalendarModal from '@/components/BatchCalendar/BatchCalendarModal';
import Icons from '@/components/third-party/Icons';
import { defaultColors } from '@/themes/antd-theme';
import { useTheme } from '@/App';

/**
 * BatchCalendarIcon Component
 * Header icon to open batch calendar modal
 * Shows badge with count of running batches
 */
const BatchCalendarIcon = () => {
  const { isDark } = useTheme();
  const [modalOpen, setModalOpen] = useState(false);
  const [runningBatchCount, setRunningBatchCount] = useState(0);

  const handleIconClick = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  // Dark mode aware colors
  const bgColor = isDark
    ? (modalOpen ? defaultColors.grey[600] : defaultColors.grey[700])
    : (modalOpen ? defaultColors.grey[300] : defaultColors.grey[100]);
  const iconColor = isDark ? defaultColors.grey[100] : defaultColors.grey[700];

  return (
    <>
      <Tooltip title="Batch Production Calendar" zIndex={9999}>
        <Button
          type="text"
          shape="circle"
          onClick={handleIconClick}
          style={{
            backgroundColor: bgColor,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 0,
          }}
          icon={
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Badge count={runningBatchCount} overflowCount={99} size="small" color={defaultColors.error}>
                <Icons.Calendar size={23} strokeWidth={2} style={{ display: 'block', color: iconColor }} />
              </Badge>
            </div>
          }
        />
      </Tooltip>
      <div style={{ zIndex: 1500, position: 'relative' }}>
        <BatchCalendarModal open={modalOpen} onClose={handleModalClose} />
      </div>
    </>
  );
};

export default BatchCalendarIcon;
